import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const taskEvidenceStateStyleId = 'work-task-evidence-state-theme';

export const taskEvidenceStateBridgeStyles = {
  'task-evidence-state': {
    '--local-evidence-state-gap': tokens.spacing.sm,
  },
};
